import {Viewport} from '@radix-ui/react-toast';

type Props = React.ComponentPropsWithRef<typeof Viewport>;
export function ToastViewport(props: Props): React.JSX.Element {
  return (
    <Viewport
      {...props}
      className="pointer-events-none fixed bottom-0 right-0 z-50 flex max-w-screen list-none flex-col gap-3 p-(--viewport-padding) outline-hidden [--viewport-padding:1.5rem] md:max-w-md"
    />
  );
}

ToastViewport.displayName = 'ToastViewport';
